'use client'
import classNames from 'classnames';
import React from 'react';

import { GameType } from '@/api/services/GameService/types';
import { getDictionary } from '@/app/[lang]/dictionaries';
import Image from '@/components/core/Image';
import Link from '@/components/core/Link';
import { _t } from '@/lib/i18n';
import ricoCardImgDj from '@/public/assets/Images/Rico/rico-dj.png';
import ricoCardImgGorilla from '@/public/assets/Images/Rico/rico-gorilla.png';
import ricoCardImgRabbit from '@/public/assets/Images/Rico/rico-rabbit.png';
import ricoCardImgRhino from '@/public/assets/Images/Rico/rico-rhino.png';
import ricoCardImgTiger from '@/public/assets/Images/Rico/rico-tiger.png';
import ricoCardImgToucano from '@/public/assets/Images/Rico/rico-toucano.png';

const config = {
  141: {
    image: ricoCardImgToucano,
    imageClassName: 'toucano',
    cardClassName: 'typeBg1',
    starClassName: 'typeColor1',
  },
  128: {
    image: ricoCardImgTiger,
    imageClassName: 'tiger',
    cardClassName: 'typeBg2',
    starClassName: 'typeColor2',
  },
  129: {
    image: ricoCardImgRabbit,
    imageClassName: 'rabbit',
    cardClassName: 'typeBg3',
    starClassName: 'typeColor3',
  },
  130: {
    image: ricoCardImgDj,
    imageClassName: 'dj',
    cardClassName: 'typeBg4',
    starClassName: 'typeColor4',
  },
  100: {
    image: ricoCardImgGorilla,
    imageClassName: 'gorilla',
    cardClassName: 'typeBg5',
    starClassName: 'typeColor5',
  },
  166: {
    image: ricoCardImgRhino,
    imageClassName: 'rhino',
    cardClassName: 'typeBg6',
    starClassName: 'typeColor6',
  },
};

export default async function RicoGamesCards({ games, lang }: { games: GameType[]; lang: string }) {
  const dict = await getDictionary(lang);

  return (
    <div className="ricoCardWrapper">
      <div className="ricoCardInner">
        <p className="ricoCardHolderTitle">{_t('Rico-Team', dict)}</p>
        <div className="ricoCardHolder">
          {games.map((game, index) => {
            const gameConfig = config[game.id as keyof typeof config];
            return (
              gameConfig && (
                <div
                  className={classNames('ricoCard', gameConfig?.cardClassName, {
                    mobileColumnReverse: index % 2,
                    mobileColumn: !(index % 2),
                  })}
                  key={game.id}
                >
                  {!!(index % 2) && (
                    <div className="ricoCardImgHolder">
                      <Image
                        src={gameConfig?.image}
                        className={`ricoCardImg ${gameConfig?.imageClassName}`}
                        alt="character image"
                      />
                    </div>
                  )}
                  <div className="ricoCardItem">
                    <div className="ricoCardItemHolder">
                      <h3 className="ricoCardItemTitle">{game.name}</h3>
                      <div className="ricoCardItemDateBlock">
                        <p className="ricoCardItemDateInfo">
                          {_t('release-date-rico-rabbit', dict)}: {game.release_date}
                        </p>
                      </div>
                      <div className="ricoCardItemFavoriteWrp">
                        {game.features?.split(',').map((feature) => (
                          <div className="ricoCardItemFavoriteRow" key={feature}>
                            <div className="ricoCardItemFavoriteIconBlock">
                              <i
                                className={`bc-i-features ricoCardItemFavoriteIcon ${gameConfig?.starClassName}`}
                              />
                            </div>
                            <p className="ricoCardItemFavoriteTitle">{feature}</p>
                          </div>
                        ))}
                      </div>
                      <div className="ricoCardItemCoefRow">
                        <div className="ricoCardItemCoefRowItem">
                          <p className="ricoCardItemCoefRowTitle">{_t('RTP-Button', dict)}</p>
                          <p className="ricoCardItemCoefRowPercent">{game.rtp}</p>
                        </div>
                        <div className="ricoCardItemCoefRowItem">
                          <p className="ricoCardItemCoefRowTitle">{_t('max-multiplier', dict)}</p>
                          <p className="ricoCardItemCoefRowPercent">{game.maxMultiplier}</p>
                        </div>
                      </div>
                      <div className="ricoCardItemBtnWrp">
                        {/* <Link href="#" className="button btnTypeBig btnTypeOutline">
                      <p>Gallery</p>
                    </Link> */}

                        <Link
                          href={`/${lang}/products/games/${game.categorySlug}/${game.slug}`}
                          className="button btnTypeBig btnTypeOrange"
                        >
                          <p>{_t('PlayDemo-Button', dict)}</p>
                          <i className="bc-i-go-to btnIcon btnIconSmall" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  {!(index % 2) && (
                    <div className="ricoCardImgHolder">
                      <Image
                        src={gameConfig?.image}
                        className={`ricoCardImg ${gameConfig?.imageClassName}`}
                        alt=""
                      />
                    </div>
                  )}
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
}
